var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contest-alias-page" }, [
    _vm.contestName
      ? _c("h1", { staticClass: "contest-name" }, [
          _vm._v(_vm._s(_vm.contestName))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "contest-content-wrap" }, [
      _c("div", { staticClass: "contest-pick-alias" }, [
        _c("span", { staticClass: "contest-info-name-details--usericon" }),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("Contests.Alias.Page.Alias")))]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.aliasModel,
              expression: "aliasModel"
            }
          ],
          attrs: { type: "text", placeholder: "Enter Alias" },
          domProps: { value: _vm.aliasModel },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.aliasModel = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contest-charge-fee" }, [
        _c("p", { staticClass: "contest-charge-fee-text" }, [
          _vm._v(_vm._s(_vm.$t("Contests.Alias.Page.Fee")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "contest-charge-fee-number" }, [
          _vm._v("$" + _vm._s(_vm.contestEntryFee))
        ])
      ]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("@/assets/images/contests/alias_contest.jpg"),
          alt: "contests-img"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex align-center contest-buttons" },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn--cancel secondary-btn",
              attrs: { to: { name: "contests" }, "active-class": "" }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("Contests.Alias.Page.Cancel")) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "btn--accept primary-btn",
              attrs: { disabled: !_vm.aliasModelTrimmed },
              on: { click: _vm.submitAlias }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("Contests.Alias.Page.Submit")) +
                  "\n      "
              )
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14238830", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14238830","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/contests/ContestAliasPage.vue
// module id = null
// module chunks = 